import React from "react";
import "./PrivacyPolicy.css"; // this contains your terms-page CSS

const PrivacyPolicy = () => {
  return (
    <div className="terms-page">
      <div className="container">
        <div className="terms-card p-4 p-md-5">

          <h2 className="text-center mb-3">
            Privacy Policy for{" "}
            <a href="https://vaibhavam.net" target="_blank" rel="noreferrer">
              vaibhavam.net
            </a>
          </h2>

          <p className="text-center text-muted mb-4">
            Last Updated: {new Date().toLocaleDateString()}
          </p>

          <p className="intro">
            Your privacy is important to us. This Privacy Policy explains how we
            collect, use, and protect your information when you use our website.
          </p>

          <div className="t-section">

            <div className="terms-section">
              <h4>1. Information We Collect</h4>
              <p>
                We may collect personal information such as your name, email
                address, and contact details when you voluntarily provide them
                through forms or other interactions on our website.
              </p>
              <p>
                We may also collect automated data such as IP address, browser
                type, device information, cookies, pages visited, time spent,
                and referring websites.
              </p>
            </div>

            <div className="terms-section">
              <h4>2. How We Use Your Information</h4>
              <p>
                We use the collected information to provide and maintain our
                services, communicate with you, improve website functionality,
                and comply with legal and security requirements.
              </p>
            </div>

            <div className="terms-section">
              <h4>3. Data Protection</h4>
              <p>
                We implement appropriate technical and organizational measures
                such as encryption, secure servers, and controlled access to
                protect your personal data.
              </p>
            </div>

          </div>

        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
